import { render, staticRenderFns } from "./Contact-Details.vue?vue&type=template&id=5b93d313"
import script from "./Contact-Details.vue?vue&type=script&lang=js"
export * from "./Contact-Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports